export default __webpack_public_path__ + "assets/front/scss/error.518fdcaf3967298f2d9f991250a78271.css";